<template>
  <div>
    <h2 class="headline mb-3">{{ $t('schduled_broadcast') }}</h2>
    <template v-if="isLoading">
      <div class="text-xs-center" style="padding-top: 24px; padding-bottom: 40px">
        <pulse-loader :color="$vuetify.theme.primary" :size="'15px'"></pulse-loader>
      </div>
    </template>
    <template v-else>
      <div class="broadcasts">
        <template v-if="scheduleList.length > 0">
          <LonBroadcastItem
            v-for="(item, index) in scheduleList"
            :key="`broadcast_sent_${index}`"
            :name="item.delivery_tag"
            :is-edit="false"
            :updated-at="item.updated_timestamp"
            :created-at="item.created_timestamp"
            :created-by="item.create_by"
            :status="item.status"
            :scheduled-by="item.schedule_timestamp"
            @edit="handleEdit(item)"
            @copy="handleCopyBroadcast(item)"
            @delete="handleDelete(item)"
            @select="handleSelect(item)"
          />
        </template>
        <template v-else>
          <p class="no-broadcast text-xs-center">{{ $t('No Sent broadcast') }}</p>
        </template>
      </div>
    </template>
    <h2 class="headline mb-3">{{ $t('Broadcasted') }}</h2>
    <template v-if="isLoading">
      <div class="text-xs-center" style="padding-top: 24px; padding-bottom: 40px">
        <pulse-loader :color="$vuetify.theme.primary" :size="'15px'"></pulse-loader>
      </div>
    </template>
    <template v-else>
      <div class="broadcasts">
        <template v-if="sentList.length > 0">
          <LonBroadcastItem
            v-for="(item, index) in sentList"
            :key="`broadcast_sent_${index}`"
            :name="item.delivery_tag"
            :is-edit="false"
            :is-delete="false"
            :updated-at="item.updated_timestamp"
            :created-at="item.created_timestamp"
            :created-by="item.create_by"
            :status="item.status"
            :category-options="categoryOptions"
            :category-id="item.lon_category_id"
            :broadcast-id="item.id"
            @edit="handleEdit(item)"
            @copy="handleCopyBroadcast(item)"
            @delete="handleDelete(item)"
            @select="handleSelect(item)"
            @update:categoryId="handleUpdateCategoryId(item, $event)"
          />
        </template>
        <template v-else>
          <p class="no-broadcast text-xs-center">{{ $t('No Sent broadcast') }}</p>
        </template>
      </div>
      <div v-if="total > 0" style="display: flex; justify-content: flex-end">
        <v-pagination v-model="page" :length="pageLength" :total-visible="7" />
      </div>
    </template>
  </div>
</template>
<script>
import LonBroadcastItem from './LonBroadcastItem.vue'
import { mapGetters } from 'vuex'
import lineOfficialNotificationApi from '@/api/line-official-notification'
import dayjs from 'dayjs'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
export default {
  components: {
    LonBroadcastItem,
    PulseLoader
  },
  props: {
    categoryOptions: {
      type: Array,
      default: () => []
    },
    filter: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      total: 0,
      scheduleList: [],
      sentList: [],
      page: 1,
      limit: 10,
      isLoading: true
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageLength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit)
      } else {
        return 1
      }
    }
  },
  watch: {
    page(newVal, oldVal) {
      if (newVal != oldVal) this.handleFetchData()
    },
    filter() {
      this.page = 1
      this.handleFetchData()
    }
  },
  mounted() {
    this.handleFetchData()
  },
  methods: {
    handleEdit(broadcast) {
      this.$emit('edit', broadcast)
    },
    handleCopyBroadcast(broadcast) {
      this.$emit('copy', broadcast)
    },
    handleDelete(broadcast) {
      this.$emit('delete', broadcast)
    },
    handleSelect(broadcast) {
      this.$emit('select', broadcast)
    },
    handleUpdateCategoryId(broadcast, categoryId) {
      this.scheduleList = this.scheduleList.map((item) => {
        if (item.id === broadcast.id) {
          return { ...item, lon_category_id: categoryId }
        }
        return item
      })

      this.sentList = this.sentList.map((item) => {
        if (item.id === broadcast.id) {
          return { ...item, lon_category_id: categoryId }
        }
        return item
      })
    },
    async handleFetchData() {
      try {
        this.isLoading = true
        const response = await lineOfficialNotificationApi.getLineOfficialNotificationList({
          params: {
            page_id: this.selectedBot.pageid,
            limit: this.limit,
            offset: this.page * this.limit - this.limit,
            status: 'sent',
            lon_category_id: this.filter.categoryId,
            delivery_tag: this.filter.search || undefined,
            start_date: dayjs(this.filter.date.start).format('YYYY-MM-DD'),
            end_date: dayjs(this.filter.date.end).format('YYYY-MM-DD')
          }
        })
        const { status, data } = response
        if ([200].includes(status)) {
          this.total = data.total || 0
          this.scheduleList = []
          this.sentList = []
          const list = data.data || []
          list.map((broadcast) => {
            if (
              !!broadcast.schedule_timestamp &&
              broadcast.status == 'sent' &&
              dayjs().isBefore(dayjs(broadcast.schedule_timestamp))
            ) {
              this.scheduleList.push(broadcast)
            } else {
              this.sentList.push(broadcast)
            }
          })
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    handleReFetch() {
      this.page = 1
      this.handleFetchData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/LonBroadcast/LonBroadcastSent.vue